/**
 * Single source of truth for Roll Review time windows.
 *
 * All deadline calculations and window constants must be imported from here.
 * Do NOT hardcode these values elsewhere.
 */

/** Time the instructor has to accept a pending review. */
export const ACCEPTANCE_WINDOW_HOURS = 48;
export const ACCEPTANCE_WINDOW_MS    = ACCEPTANCE_WINDOW_HOURS * 60 * 60 * 1000;

/**
 * Time the instructor has to deliver feedback once accepted.
 *
 * Canonical value for the delivery window. Must match the schema default on
 * `roll_reviews.turnaround_hours`, the Deno-side `_shared/reviewWindows.ts`,
 * and the push-notification copy ("They have 72h to deliver…").
 */
export const DELIVERY_WINDOW_HOURS = 72;
export const DELIVERY_WINDOW_MS    = DELIVERY_WINDOW_HOURS * 60 * 60 * 1000;

/** Acceptance deadline: 48 h from submission. */
export const acceptanceDeadline = (video: { created_at: string }): Date =>
  new Date(new Date(video.created_at).getTime() + ACCEPTANCE_WINDOW_MS);

/** Delivery deadline: 72 h from acceptance (updated_at when status → under_review). */
export const deliveryDeadline = (video: { updated_at: string }): Date =>
  new Date(new Date(video.updated_at).getTime() + DELIVERY_WINDOW_MS);

/** Returns true if the 48 h acceptance window has passed. */
export const isAcceptanceExpired = (createdAt: string): boolean =>
  Date.now() - new Date(createdAt).getTime() > ACCEPTANCE_WINDOW_MS;
